const CORP_KEY_STORAGE_KEY = 'corpKey'

function getQueryCorpKey() {
  if (typeof window === 'undefined') {
    return ''
  }
  const href = window.location.href || ''
  const queryStart = href.indexOf('?')
  if (queryStart === -1) {
    return ''
  }
  const queryEnd = href.indexOf('#', queryStart)
  const search = href.substring(queryStart + 1, queryEnd === -1 ? href.length : queryEnd)
  const params = new URLSearchParams(search)
  return params.get('corpKey') || ''
}

function getEnvCorpKey() {
  return process.env.VUE_APP_CORP_KEY || ''
}

function getStoredCorpKey() {
  if (typeof window === 'undefined' || !window.localStorage) {
    return ''
  }
  return window.localStorage.getItem(CORP_KEY_STORAGE_KEY) || ''
}

export function getCorpKeyFromContext() {
  const queryCorpKey = getQueryCorpKey()
  if (queryCorpKey) {
    window.localStorage.setItem(CORP_KEY_STORAGE_KEY, queryCorpKey)
    return queryCorpKey
  }
  return getEnvCorpKey() || getStoredCorpKey()
}

export function shouldAppendCorpKey(url) {
  if (!url) {
    return false
  }
  return [
    'lechun-cms/scrmCalendar/getQwUser',
    'lechun-cms/moment/',
    'lechun-cms/qiyeweixin/',
    'lechun-cms/qiWeiPerformanceMember/',
    'lechun-cms/user/getQiWeiUserInfoList',
    'lechun-bi/generateScene/getQw'
  ].some(item => url.indexOf(item) > -1)
}

export function appendCorpKeyIfNeeded(url, params = {}) {
  if (!shouldAppendCorpKey(url)) {
    return params || {}
  }
  const corpKey = getCorpKeyFromContext()
  if (!corpKey) {
    return params || {}
  }
  if (typeof FormData !== 'undefined' && params instanceof FormData) {
    if (!params.has('corpKey')) {
      params.append('corpKey', corpKey)
    }
    return params
  }
  return {
    ...(params || {}),
    corpKey
  }
}
